import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

type Result = {
  isCampaignTermsEnabled: boolean;
  disclaimer?: string;
};

const FEATURE_FLAG_NAME = 'qantas-hotels-campaign-terms';

const useCampaignTerms = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false, variables } = decision || {};

  if (!isReady) {
    return {
      isCampaignTermsEnabled: false,
      disclaimer: undefined,
    };
  }

  return {
    isCampaignTermsEnabled: enabled,
    disclaimer: enabled ? variables?.disclaimer : undefined,
  };
};

export default useCampaignTerms;
